export function formatPrice(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export function toNumericPrice(value?: string | number | null): number | null {
  if (value == null || value === '') return null
  const num = typeof value === 'number' ? value : Number(String(value).replace(/,/g, '').trim())
  return Number.isFinite(num) ? num : null
}

export function getPrice(value?: string | number | null): string | null {
  const num = toNumericPrice(value)
  if (num == null || num <= 0) return null
  return String(value).trim()
}
